import { clsx } from 'clsx'

import { Empty } from '../Common/Empty'
import type { DraftPreview, PostType, ProfilePreview } from '../types'
import { TikTokPost } from './components/Post'
import commonStyles from '../Common/Common.module.css'
import { PostPreviewCard } from '../Common/styles'

import styles from './TikTokPreview.module.css'

import type { JSX } from 'react'

export const TikTokPreview = ({
  draft,
  profile,
}: {
  draft: DraftPreview
  profile: ProfilePreview
}): JSX.Element => {
  const draftTikTok: PostType = {
    content: {
      ...draft,
      text: draft.text,
    },
  }

  if (draft.isEmpty) return <Empty />

  return (
    <PostPreviewCard
      data-testid="tiktok-preview"
      className={clsx(commonStyles.videoPreview, styles.tikTokPreview)}
    >
      <TikTokPost content={draftTikTok.content} profile={profile} />
    </PostPreviewCard>
  )
}
